import { useSuspenseQuery } from '@tanstack/react-query';

import {
  getChapterValidationOptions,
  useValidateChapter,
} from '@/module/Author/Chapter/Validation/model/ChapterValidationModel';

import { Id, useAppNotification } from '@feature/utils';
import { ValidationRequest, ValidationVariant } from '@feature/validation';
import { ValidationAction } from '@feature/validation/ValidationAction';

interface ValidationActionProps {
  chapterId: Id;
  variant?: ValidationVariant;
}

export function ChapterValidationAction({ chapterId, variant }: ValidationActionProps) {
  const { data } = useSuspenseQuery(getChapterValidationOptions(chapterId));
  const notification = useAppNotification();
  const { mutate, isPending } = useValidateChapter(chapterId);

  const onSubmit = (request: ValidationRequest) => {
    mutate(request, {
      onSuccess: notification.success,
      onError: notification.error,
    });
  };

  return (
    <ValidationAction
      validation={data}
      isPending={isPending}
      onSubmit={onSubmit}
      variant={variant}
    />
  );
}
